var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styleMain},[_c('span',[_vm._v("Possession de balle")]),_c('el-slider',{attrs:{"min":0,"max":100,"show-input":true,"show-input-controls":false,"input-size":"mini","show-tooltip":false},on:{"change":_vm.update},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }